$(document).ready(function () {
  $('.select2').select2({
    width: '100%'
  });

  $('.datepicker').daterangepicker({
    singleDatePicker: true,
    locale: {
      format: config('format.date'),
    }
  });

  $('.datetimepicker').daterangepicker({
    timePicker: true,
    timePicker24Hour: true,
    singleDatePicker: true,
    locale: {
      format: config('format.datetime'),
    }
  });
});
